module.exports = __webpack_public_path__ + "img/logo_just.de923bef.png";